module.exports = __webpack_public_path__ + "img/Random_forest_diagram_complete.8b4a3c9a.png";